class Blackjack {
	mobile = false;
	clicked = false;

	$anchors!: NodeListOf<HTMLAnchorElement>;
	rollingEntries!: NodeListOf<HTMLElement>;
	rollingVideos!: NodeListOf<HTMLVideoElement>;
	rollingHoverElements!: NodeListOf<HTMLElement>;

	init() {
		this.relativeVariables();
		this.cache();
		this.events();
	}

	cache() {
		this.$anchors = document.querySelectorAll('a');
		this.rollingEntries = document.querySelectorAll('.blackjackRolling .entry');
		this.rollingVideos = document.querySelectorAll('.blackjackRolling .video');
		this.rollingHoverElements = document.querySelectorAll(
			'.blackjackRolling .desktopIcon, .blackjackRolling .text'
		);
	}

	events() {
		window.addEventListener('optimizedResize', this.relativeVariables.bind(this));
		for (let i = this.$anchors.length - 1; i >= 0; i--) {
			this.$anchors[i].addEventListener('click', this.userInteracted.bind(this));
		}
		for (let i = this.rollingHoverElements.length - 1; i >= 0; i--) {
			this.rollingHoverElements[i].addEventListener(
				'mouseenter',
				this.rollingMouseenter.bind(this)
			);
			this.rollingHoverElements[i].addEventListener('click', this.rollingClick.bind(this));
			this.rollingHoverElements[i].addEventListener(
				'mouseleave',
				this.rollingMouseleave.bind(this)
			);
		}
	}

	relativeVariables() {
		this.mobile = window.innerWidth < 1200;
	}

	userInteracted() {
		this.clicked = true;
	}

	rollingMouseenter(e: MouseEvent) {
		if (!this.clicked || this.mobile) return;
		this.activateVideo(e);
	}

	rollingClick(e: MouseEvent) {
		if (this.clicked || this.mobile) return;
		this.clicked = true;
		const entry = e.currentTarget as HTMLElement;
		if (entry.parentNode instanceof HTMLElement && entry.parentNode.classList.contains('active')) {
			this.rollingDeactivate();
		} else {
			this.activateVideo(e);
		}
	}

	activateVideo(e: MouseEvent) {
		const target = e.currentTarget as HTMLElement;
		const entry = target.parentNode as HTMLElement;
		entry.classList.add('active');
		const slug = entry.getAttribute('data-slug');
		if (!slug) return;
		const video = document.querySelector('.' + slug + 'Video') as HTMLVideoElement | null;
		if (!video) return;
		video.classList.add('active');
		video.play();
	}

	rollingMouseleave() {
		if (this.mobile) return;
		this.rollingDeactivate();
	}

	rollingDeactivate() {
		for (let i = this.rollingEntries.length - 1; i >= 0; i--) {
			this.rollingEntries[i].classList.remove('active');
			this.rollingVideos[i].classList.remove('active');
			this.rollingVideos[i].pause();
		}
	}
}

new Blackjack().init();
